import type {ReactElement} from 'react';

import TransactionFilters from '@/components/transactions/TransactionFilters';

import type {TransactionFiltersProps} from './types';

const TransactionFilterBar = ({
  transactions,
  exportFilters,
  filterCount,
  currentFilters,
  filtersToApply,
  clearFilters,
  selectCurrentFilters,
  selectAppliedFilters,
  handleApplyFilters,
}: TransactionFiltersProps): ReactElement => (
  <TransactionFilters
    transactions={transactions}
    exportFilters={exportFilters}
    filterCount={filterCount}
    currentFilters={currentFilters}
    filtersToApply={filtersToApply}
    clearFilters={clearFilters}
    selectCurrentFilters={selectCurrentFilters}
    selectAppliedFilters={selectAppliedFilters}
    handleApplyFilters={handleApplyFilters}
  />
);
export default TransactionFilterBar;
